import type { Theme } from "@mui/material";
import { saveAs } from "file-saver";
import type { Schemas } from "../apis/norsk-gassnett-api-hooks";

const currencyCodeTable = {
	NOK: "kr",
};
export const numberToPrice = (n: number, currencyCode?: string) => {
	if (Number.isNaN(n) || typeof n === "string") return "NaN";
	const price = n.toFixed(2).replace(".", ",");
	if (!currencyCode) return price;
	const suffix =
		currencyCodeTable[currencyCode as keyof typeof currencyCodeTable] ??
		` ${currencyCode}`;
	return price + suffix;
};
export const getBorderRadius = (t: Theme) => ({
	xs: 0,
	// biome-ignore lint/suspicious/noExplicitAny: have to use any as we don't have the type
	sm: (t?.components?.MuiPaper?.styleOverrides?.root as any)?.borderRadius,
});

export const getAddressStringForCustomer = (
	customer: Pick<
		Schemas["MeResponseBody"]["current"],
		"address2" | "visitingPostCode" | "visitingCity"
	>,
) => {
	return `${customer.address2}, ${customer.visitingPostCode} ${customer.visitingCity}`;
};

export function dateFormat(date: Date = new Date()) {
	return date.toISOString().split("T")[0];
}

interface DownloadFileProps {
	name: string;
	/** Base64 string */
	data: string;
	type?: string;
}

export const downloadFile = ({
	name,
	data,
	type = "application/pdf",
}: DownloadFileProps) => {
	const byteString = atob(data);
	const arrayBuffer = new ArrayBuffer(byteString.length);
	const int8Array = new Uint8Array(arrayBuffer);
	for (let i = 0; i < byteString.length; i++) {
		int8Array[i] = byteString.charCodeAt(i);
	}
	const blob = new Blob([int8Array], { type });
	saveAs(blob, name);
};

export const stringToColor = (string: string) => {
	let hash = 0;
	for (let i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash);
	}

	const wheel = (hash % 3600) / 10;
	const color = `hsl(${wheel}, 60%, 70%)`;

	return color;
};

export function capitalizeFirstLetter(text: string): string {
	return text.charAt(0).toUpperCase() + text.slice(1);
}

export function getMonthName(dateString: string, locale?: string) {
	const date = new Date(dateString);
	const monthName = new Intl.DateTimeFormat(locale, { month: "long" }).format(
		date,
	);
	return capitalizeFirstLetter(monthName);
}
